import makeStyles from '@material-ui/core/styles/makeStyles';
import green from '@material-ui/core/colors/green';

const useStyle = makeStyles(theme => ({
  infoDialog: {
    width: 540,
    height: 260,
  },
}));

export default useStyle;
